import React from 'react';
import ProductList from './ProductList';
import BtnAll from '../images/btn_seeall.png';

function Seemore() {

    return (
        <div class="max-w-full px-4 py-0 sm:px-6 lg:px-0 lg:py-0 mx-auto bg-[#fefaed]">
            <div class="max-w-7xl mx-auto">
                <section class="py-0 text-center">
                    <button class="mt-1 px-6 py-0"><img src={BtnAll} style={{ width: 150 }} /></button>
                </section>
            </div>
        </div>
    );
}

export default Seemore;
